import { render, staticRenderFns } from "./CreateLevelModal.vue?vue&type=template&id=a354044a&scoped=true"
import script from "./CreateLevelModal.vue?vue&type=script&lang=js"
export * from "./CreateLevelModal.vue?vue&type=script&lang=js"
import style0 from "./CreateLevelModal.vue?vue&type=style&index=0&id=a354044a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a354044a",
  null
  
)

export default component.exports